/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Project = {
  /**
   * The unique identifier of the project, generated by Teral.
   *
   * @remarks
   */
  id: string;
  /**
   * Human-readable name for this project.
   *
   * @remarks
   */
  name: string;
  /**
   * URL-safe handle for this project, unique within your workspace.
   *
   * @remarks
   * This is the caller-defined identifier used to reference the project in get, update, and delete operations.
   */
  slug: string;
  /**
   * Unix timestamp in milliseconds when the project was created.
   *
   * @remarks
   */
  createdAt: number;
  /**
   * Unix timestamp in milliseconds when the project was last updated.
   *
   * @remarks
   * Omitted if the project has never been updated.
   */
  updatedAt?: number | undefined;
  /**
   * Whether delete protection is enabled for this project.
   *
   * @remarks
   * When true, the project cannot be deleted until protection is disabled.
   */
  deleteProtection: boolean;
};

/** @internal */
export const Project$inboundSchema: z.ZodType<Project, z.ZodTypeDef, unknown> =
  z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    createdAt: z.number().int(),
    updatedAt: z.number().int().optional(),
    deleteProtection: z.boolean(),
  });

export function projectFromJSON(
  jsonString: string,
): SafeParseResult<Project, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Project$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Project' from JSON`,
  );
}
